import * as React from 'react';

const Maestro = (props: React.ComponentProps<'svg'>) => (
  <svg
    viewBox="0 0 58 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    <rect x="0.5" y="0.5" width="57" height="39" rx="5.5" fill="white" />
    <rect x="0.5" y="0.5" width="57" height="39" rx="5.5" stroke="#E5E7EB" />
    <path
      d="M21.0479 8.33337C27.1493 8.33337 32.0954 13.3369 32.0957 19.5092C32.0957 25.6816 27.1495 30.6859 21.0479 30.6859C14.9463 30.6858 10 25.6816 10 19.5092C10.0003 13.3369 14.9464 8.33346 21.0479 8.33337Z"
      fill="#ED0006"
    />
    <path
      d="M35.3804 8.33337C41.4819 8.33337 46.428 13.3369 46.4283 19.5092C46.4283 25.6816 41.482 30.6859 35.3804 30.6859C29.2788 30.6858 24.3326 25.6816 24.3326 19.5092C24.3328 13.337 29.279 8.33346 35.3804 8.33337Z"
      fill="#0099DF"
    />
    <path
      d="M28.2135 11.0062C30.5884 13.0562 32.0963 16.1044 32.0963 19.5101C32.0962 22.9154 30.588 25.9623 28.2135 28.0121C25.8396 25.9623 24.3328 22.9149 24.3326 19.5101C24.3326 16.1049 25.8392 13.0561 28.2135 11.0062Z"
      fill="#6C6BBD"
    />
  </svg>
);

export default Maestro;
